export function isError(obj) {
    return obj instanceof Error
}

export function isProduction() {
    return window.appConfig?.VUE_APP_ENV === 'production'
}
